<template>
    <form-partition :title="title">
        <Table
            ref="mt"
            :columns="columns"
            :data="list"
            height="350"
            editMode="grid"
        >
            <template v-slot:degree="{ row, column, cellEditing }">
                <cell-input-number
                    :row="row"
                    :column="column"
                    :cellEditing="cellEditing"
                    field="degree"
                    @on-change="degreeChange"
                ></cell-input-number>
            </template>
            <template v-slot:price="{ row }">
                {{ row.price }}
                {{ row.unit }}
            </template>
            <template v-slot:amount="{ row, column, cellEditing }">
                <cell-input-number
                    :row="row"
                    :column="column"
                    :cellEditing="cellEditing"
                    field="amount"
                    @on-change="expenseChange"
                ></cell-input-number>
            </template>
        </Table>
        <div class="totalPrice">清算统计：{{ totalPrice | currency }}元</div>
    </form-partition>
</template>

<script>
import { mapCell, editCell } from "_c/grid/renderCell";

import { CellInputNumber } from "ivux";
export default {
    name: "MeterSettlement",
    props: {
        value: {
            type: Array,
            default: () => [],
        },
        title: {
            type: String,
            default: "读数清算",
        },
    },
    components: { CellInputNumber },
    data() {
        return {
            list: this.value,
            addFee: "",
        };
    },
    computed: {
        columns() {
            return [
                {
                    key: "meterName",
                    title: "类型",
                    align: "left",
                    minWidth: 80,
                },
                {
                    key: "lastDegree",
                    title: "上次度数",
                    align: "left",
                    minWidth: 120,
                },
                {
                    key: "degree",
                    title: "本次度数",
                    align: "left",
                    minWidth: 120,
                    slot: "degree",
                },
                {
                    key: "dosage",
                    title: "用量",
                    align: "left",
                    minWidth: 120,
                },
                {
                    key: "price",
                    title: "单价",
                    align: "left",
                    minWidth: 120,
                    slot: "price",
                },
                {
                    key: "amount",
                    title: "应收(元)",
                    align: "left",
                    minWidth: 120,
                    slot: "amount",
                },
            ];
        },
        totalPrice() {
            const result = this.list.reduce(
                (acc, v) => (acc += v.amount - 0),
                0
            );
            return result;
        },
    },
    created() {},
    methods: {
        // 与生成账单相关的数据发生改变
        expenseChange() {
            this.$emit("on-change");
        },
        // 本次度数更改
        degreeChange(val, { row }) {
            row.dosage = row.degree - row.lastDegree;
            row.amount = row.dosage * row.price;
            this.expenseChange();
        },
    },
};
</script>

<style lang="less" scoped>
.chooseFeeType {
    background: #fff;
    text-align: center;
    line-height: 50px;
    border: 1px solid #dcdee2;
    border-top: none;
}
.totalPrice {
    font-size: 16px;
    text-align: left;
    color: #333333;
    margin-top: 23px;
}
</style>
